import { PropsWithChildren } from "react";

import { css, keyframes } from "@compiled/react";

import { media } from "@atlaskit/primitives";

import { wacToken } from "@/libraries/design/foundations";
import { SubColumnLayout } from "@/libraries/design/foundations";

const scaleUp = keyframes({
    from: {
        transform: "scale(0.7925)"
    }
});
const containerStyles = css({
    "transformOrigin": "50% 50%",
    "@media (prefers-reduced-motion: no-preference)": {
        [media.above.sm]: {
            animationName: scaleUp,
            animationRange: "exit-crossing 20px exit-crossing 200px",
            animationTimeline: "scroll(block root)",
            animationTimingFunction: wacToken("motion.easing.ease-both"),
            animationFillMode: "backwards"
        }
    }
});

export const ScrollToEnlarge = ({ children }: PropsWithChildren) => {
    return (
        <SubColumnLayout layout="10">
            <div css={containerStyles}>{children}</div>
        </SubColumnLayout>
    );
};
